import React from "react";
import { useDispatch } from "react-redux";
import { Confirm } from "semantic-ui-react";
import { partnerCategoryDelete } from "../../../store/actions/partnersActions";

const DeleteCategory = (props) => {
  const dispatch = useDispatch();
  return (
    <Confirm
      open={props.open}
      content="You Sure Want To Delete ? You Can't Undo It"
      onCancel={() => {
        props.close();
      }}
      onConfirm={() => {
        dispatch(partnerCategoryDelete(props.open));
        props.close();
      }}
    />
  );
};

export default DeleteCategory;
